
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/purchase-summary",
      function () {
        return require("private-next-pages/quick-purchase/purchase-summary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-purchase/purchase-summary"])
      });
    }
  